var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M84.3546 60.5131C84.4946 59.9101 84.6561 59.3286 84.7961 58.7149C86.4651 51.1665 85.8406 44.4042 83.6008 38.6434L81.0919 33.604C70.2055 11.7557 32.2915 5.57493 18.2285 38.9449C17.6362 40.4201 17.1194 41.9168 16.6994 43.4459C8.92496 71.9164 30.7732 83.0828 41.1212 85.9147C48.8849 88.036 59.1252 88.7467 67.998 83.8904C67.998 83.8904 80.6073 77.1927 84.3546 60.5239V60.5131Z",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.9148 29.5878L43.2866 27.9834L61.4091 41.9602L70.2066 37.933C71.7248 37.2331 73.4262 37.007 75.0844 37.2762L76.1289 37.4484C77.4426 37.6638 78.2933 38.956 77.9595 40.2481L77.8734 40.5819C77.518 42.0141 76.592 43.2416 75.3106 43.9846L66.287 49.8639L65.964 73.4135L61.6568 76.0947L56.1328 54.3003L45.5694 58.9521L41.9299 60.2765L41.3915 67.5126L39.0333 68.5463L36.6428 61.5149L33.4555 60.8472L34.963 58.1229L31.248 51.5976L33.4124 49.8101L38.8287 54.268L50.8996 46.052L36.772 30.5785L38.9364 29.6094L38.9148 29.5878Z",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.1813 52.0283C15.1813 52.0283 -2.27356 65.5852 5.25325 70.1508C11.5956 73.9196 24.711 65.9836 33.433 60.8365",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M82.9554 36.1774C82.9554 36.1774 99.6996 25.0541 97.4168 19.6701C93.7772 11.0988 79.1543 20.7038 79.1543 20.7038",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M80.2632 13.457L78.0234 21.393L85.378 23.4282",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.525c708c2ed77e7c883be96d575bff33.svg";
export { ForwardRef as ReactComponent };